import { OptionsGroupField } from "@imi-ernd-be/hyselect-engine";
import { assert } from "radashi";
import { toArray } from "../../vector";
import {
  getOptionsFieldDefinition,
  OptionsFieldDefinition,
} from "./getOptionsFieldDefinition";

export type OptionsGroupFieldDefinition = {
  default: string;
  disabled: boolean;
  groups: OptionsFieldDefinition[];
  translationKey: string;
  type: "optionsGroups";
};

export function getOptionsGroupDefinition(
  groups: OptionsGroupField | null,
): OptionsGroupFieldDefinition {
  assert(groups, "OptionsGroupField is null in getOptionsGroupDefinition");
  const defaultOption = groups.getDefaultOption()?.id;
  const optionsGroup = {
    default: defaultOption ?? toArray(groups.getOptionGroup())[0]?.id ?? "",
    disabled: groups.disabled,
    groups: toArray(groups.getOptionGroup()).map((group) =>
      getOptionsFieldDefinition(group),
    ),
    translationKey: groups.translationKey,
    type: "optionsGroups" as const,
  };

  return optionsGroup;
}
